var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-totally-block"},[_c('div',{staticClass:"head-totally-block__inner"},[_c('div',{staticClass:"head-totally-block__item totally"},[_vm._t("title")],2),_c('div',{staticClass:"head-totally-block__list"},[_vm._t("item")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }